import React, { useRef, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  AddImageIcon,
  AddImageIconDisabled,
  certificate,
  EditIconGray,
  LinkIcon,
  logoColor,
  TrashIconGray,
  AddIconBlue,
  PdfImg,
} from "../../../../constant/imagePath";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import classes from "./PersonalInfoMobile.module.css";
import { Row, Col, Container } from "react-bootstrap";
import { Radio } from "../../../../stories/Radio/Radio";
import { Input } from "../../../../stories/Input/Input";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { useHistory } from "react-router-dom";
import AddImageComponent from "../../../../components/AddImage/AddImage";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { UploadedImageWithEditAndDelete } from "../../../../stories/UploadedImageWithEditAndDelete/UploadedImageWithEditAndDelete";
import { ImageAndVideoBoxWithDeleteBtn } from "../../../../stories/ImageAndVideoBoxWithDeleteBtn/ImageAndVideoBoxWithDeleteBtn";
import MobileEditPhotoModal from "../../../../components/Modals/CoachFlow/OnBoarding/MobileEditPhotoModal/MobileEditPhotoModal";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import CertificateInformationCard from "../../../../stories/CertificateInformationCard/CertificateInformationCard";
import { calc } from "@chakra-ui/react";

export default function PersonalInfoMobile({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer?.personalInfo
  );
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [editedCoverPhoto, setEditedCoverPhoto] = useState(
    getDataFromRedux?.coverPhoto ? getDataFromRedux?.coverPhoto : null
  );
  const [dob, setDob] = useState(
    getDataFromRedux?.dob ? getDataFromRedux?.dob : null
  );
  const [phoneNo, setPhoneNo] = useState(
    getDataFromRedux?.phone ? getDataFromRedux?.phone : ""
  );

  const [gender, setGender] = useState(
    getDataFromRedux?.gender ? getDataFromRedux?.gender : null
  );
  const [fullName, setFullName] = useState(
    getDataFromRedux?.fullName ? getDataFromRedux?.fullName : ""
  );
  const [aboutYourself, setAboutYourself] = useState(
    getDataFromRedux?.aboutYourself ? getDataFromRedux?.aboutYourself : ""
  );
  const [coachingExperience, setCoachingExperience] = useState(
    getDataFromRedux?.coachingExperience
      ? getDataFromRedux?.coachingExperience
      : ""
  );
  const [areaOfExpertise, setAreaOfExpertise] = useState(
    getDataFromRedux?.areaOfExpertise ? getDataFromRedux?.areaOfExpertise : ""
  );
  const [focusTags, setFocusTags] = useState(
    getDataFromRedux?.focusTags ? getDataFromRedux?.focusTags : []
  );
  const [levelsTaught, setLevelsTaught] = useState(
    getDataFromRedux?.levelsTaught ? getDataFromRedux?.levelsTaught : []
  );
  const [teaches, setTeaches] = useState(
    getDataFromRedux?.teaches ? getDataFromRedux?.teaches : []
  );
  const [addPhotpOrVideo, setAddPhotoOrVideo] = useState(
    getDataFromRedux?.addPhotpOrVideo ? getDataFromRedux?.addPhotpOrVideo : []
  );

  const [certificates, setCertificates] = useState([]);

  // Add Certficate States
  const certificateRef = useRef(null);
  const [certificateImg, setCertificateImg] = useState(null);
  const [certifications, setCertifications] = useState(null);
  const [expirationDate, setExpirationDate] = useState(null);

  const [isOpenEditPhotoModal, setIsOpenEditPhotoModal] = useState(false);
  const coverRef = useRef(null);
  const multipleFilesRef = useRef(null);

  function addCoverPhoto() {
    coverRef.current.click();
  }
  function editCoverPhoto() {
    coverRef.current.click();
    setEditedCoverPhoto(null);
  }
  function deleteCoverPhoto() {
    setCoverPhoto(null);
    setEditedCoverPhoto(null);
  }

  function removePhotoOrVideo(data) {
    const newArr = addPhotpOrVideo.slice();
    const index = newArr?.findIndex((item) => item?.name === data.name);
    if (index !== -1) {
      newArr.splice(index, 1);
      setAddPhotoOrVideo(newArr);
    }
  }

  function saveAndFinishLater() {
    const res = {
      coverPhoto,
      gender,
      fullName,
      aboutYourself,
      coachingExperience,
      areaOfExpertise,
      focusTags,
      levelsTaught,
      teaches,
      certificates,
      addPhotpOrVideo,
    };
    dispatch(setPersonalData("personal-info", res));
  }
  console.log({ certificates });

  return (
    <div className={classes.PersonalInfoMobile}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"33.3%"} />
      </div>

      <style jsx>{`
        .${classes.multipleImageCard}::before {
          background-color: ${Colors.neutralShadesOfNero}80;
        }
      `}</style>
      <Row className={`g-0 ${[classes.personalInfoForm].join(" ")}`}>
        <Col md={12} sm={12}>
          <h3
            style={{
              ...Fonts.h3,
              color: Colors.neutralShadesOfNero,
              fontSize: "24px",
              lineHeight: "32px",
              fontWeight: 400,
            }}
          >
            Personal Info
          </h3>
          <p
            className={`${[classes.formTagline].join(" ")}`}
            style={{
              ...Fonts.p2,
              color: Colors.neutralShadesOfDimGray,
            }}
          >
            Introduce yourself to your students
          </p>
        </Col>
        <Col md={12} sm={12} className={`${[classes.mb32].join(" ")}`}>
          {typeof editedCoverPhoto !== "object" && editedCoverPhoto !== null ? (
            <UploadedImageWithEditAndDelete
              image={editedCoverPhoto}
              editClick={() => editCoverPhoto()}
              deleteClick={() => deleteCoverPhoto()}
            />
          ) : (
            <Button
              customStyle={{
                border: `1px dashed ${Colors.neutralShadesOfGainsboro}`,
                height: "64px",
                borderRadius: "10px",
                width: "100%",
                color: Colors.mainBlue,
              }}
              icon={AddImageIcon}
              size={"Medium"}
              onClick={addCoverPhoto}
              label={"Add cover photo"}
            />
          )}

          <input
            className="d-none"
            type={"file"}
            accept="image/*"
            ref={coverRef}
            onChange={(e) => {
              setCoverPhoto(e.target.files[0]);
              setIsOpenEditPhotoModal(true);
            }}
            onClick={(event) => {
              event.target.value = null;
            }}
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <Input
            label={"Full Name"}
            state={fullName}
            setter={setFullName}
            placeholder=""
            customStyle={{ width: "100%" }}
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <Input
            label={"Phone number"}
            state={phoneNo}
            setter={setPhoneNo}
            placeholder=""
            inputStyle={{ height: "48px" }}
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <Input
            label={"Date of birth"}
            state={dob}
            setter={setDob}
            placeholder=""
            inputStyle={{ height: "48px" }}
          />
        </Col>

        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <DropDown
            state={gender}
            setter={setGender}
            label={"Gender"}
            options={[
              { label: "Male", value: "Male" },
              { label: "Female", value: "Female" },
              { label: "Others", value: "Other" },
            ]}
            placeholder={"Select your gender"}
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <TextArea
            label={
              "Tell a little about yourself. What makes you a great coach?"
            }
            state={aboutYourself}
            setter={setAboutYourself}
            textAreaStyle={{ minHeight: "148px", maxHeight: "148px" }}
          />
        </Col>
        <Col md={12} className={classes.mb32}>
          <div className={`${[classes.spaceBetween].join(" ")}`}>
            <h5
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
                fontSize: "24px",
                lineHeight: "32px",
                fontWeight: 400,
                color: Colors.neutralShadesOfNero,
              }}
            >
              Credentials and Experience
            </h5>
            <span
              style={{
                ...Fonts.p4,
                color: Colors.neutralShadesOfDimGray,
              }}
            >
              Optional
            </span>
          </div>
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <TextArea
            placeholder=""
            label="What is your area of expertise?"
            state={areaOfExpertise}
            setter={setAreaOfExpertise}
          />
        </Col>

        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <Input
            label={"Extensive coaching experience"}
            state={coachingExperience}
            setter={setCoachingExperience}
            placeholder=""
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <DropDown
            label={
              "Focus tags (What part of the game can you improve your student?)"
            }
            isMulti={true}
            state={focusTags}
            setter={setFocusTags}
            options={[
              { value: "Forehand", label: "Forehand" },
              { value: "Backhand", label: "Backhand" },
              { value: "Volley", label: "Volley" },
              { value: "Serve", label: "Serve" },
              { value: "Slice", label: "Slice" },
              { value: "Mobility", label: "Mobility" },
            ]}
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <DropDown
            label={"Levels Taught"}
            isMulti={true}
            state={levelsTaught}
            setter={setLevelsTaught}
            options={[
              { value: "Beginner", label: "Beginner" },
              { value: "Intermediate", label: "Intermediate" },
              { value: "Advanced", label: "Advanced" },
              { value: "Expert", label: "Expert" },
            ]}
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <DropDown
            label={"Teaches"}
            isMulti={true}
            state={teaches}
            setter={setTeaches}
            options={[{ value: "Kids", label: "Kids" }]}
          />
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <Row className="gy-2 gx-2">
            <Col sm={12} xs={12}>
              <DropDown
                label={"What certifications/licenses do you hold?"}
                labelTwo={"(Optional)"}
                state={certifications}
                setter={setCertifications}
                placeholder="Select Certificate"
                options={[
                  { value: "ABC", label: "ABC" },
                  { value: "XYZ", label: "XYZ" },
                ]}
              />
            </Col>
            <Col sm={12} xs={12} className={classes.expirationAndLink}>
              <Input
                placeholder={"Expiration Date"}
                state={expirationDate}
                setter={setExpirationDate}
                customStyle={{ width: "calc(100% - 56px)" }}

              />

              <Button
                icon={LinkIcon}
                customStyle={{ width: "48px", height: "48px" }}
                onClick={() => {
                  certificateRef.current.click();
                }}
              />
            </Col>
            {/* Render Certificates */}
            {certificates.map((item) => {
              return (
                <Col md={12} key={item?._id}>
                  <CertificateInformationCard
                    data={item}
                    onDelete={() => {
                      const newArr = [...certificates];
                      const index = newArr.findIndex((d) => d._id);
                      newArr.splice(index, index + 1);
                      setCertificates(newArr);
                    }}
                  />
                </Col>
              );
            })}

            {/* Add Certficate */}
            <Col
              md={12}
              className={`${[classes.mb16, classes.mt16].join(" ")}`}
            >
              <LinkButtonWithIcon
                primary={true}
                text={"Add certificate"}
                leftIcon={AddIconBlue}
                disabled={
                  certifications == null ||
                    expirationDate == "" ||
                    certificateImg == null
                    ? true
                    : false
                }
                onClick={() => {
                  const newArr = [...certificates];
                  newArr.push({
                    _id: Math.floor(Math.random() * 10000),
                    title: certifications?.label,
                    size: Math.ceil(certificateImg?.size / (1024 * 1024)),
                    date: expirationDate,
                    certificateImg: certificateImg,
                  });
                  setCertificates(newArr);
                  setCertifications(null);
                  setExpirationDate("");
                  setCertificateImg(null);
                }}
              />
            </Col>
          </Row>
        </Col>
        {/* Hidden Input For Certificate Img */}
        <input
          type={"file"}
          ref={certificateRef}
          className={"d-none"}
          accept="image/png, image/jpeg, application/pdf"
          onChange={(e) => setCertificateImg(e.target.files[0])}
          onClick={(event) => {
            event.target.value = null;
          }}
        />

        <Col md={12} className={classes.mb32}>
          <div className={`${[classes.spaceBetween].join(" ")}`}>
            <h5
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
                fontSize: "24px",
                lineHeight: "32px",
                fontWeight: 400,
                color: Colors.neutralShadesOfNero,
              }}
            >
              Gallery
            </h5>
            <span
              style={{
                ...Fonts.p4,
                color: Colors.neutralShadesOfDimGray,
              }}
            >
              Optional
            </span>
          </div>
          <p
            className={`${[classes.addUpto].join(" ")}`}
            style={{
              ...Fonts.b1,
              fontFamily: "inter-400",
              lineHeight: "24px",
              color: Colors.neutralShadesOfDimGray,
            }}
          >
            You can upload a maximum of 8 photos or videos
          </p>
        </Col>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <Button
            customStyle={{
              border: `1px dashed ${Colors.neutralShadesOfGainsboro}`,
              height: "64px",
              borderRadius: "10px",
              width: "100%",
              color:
                addPhotpOrVideo?.length < 8
                  ? Colors.mainBlue
                  : Colors.neutralShadesOfPinkSwan,
            }}
            icon={AddImageIcon}
            disabledIcon={AddImageIconDisabled}
            disabled={addPhotpOrVideo?.length < 8 ? false : true}
            size={"Medium"}
            onClick={() => multipleFilesRef.current.click()}
            label={"Add photo or video"}
          />
          {/* Hidden Input */}
          <input
            type="file"
            className="d-none"
            accept="video/*, image/*"
            ref={multipleFilesRef}
            multiple
            onChange={(e) => {
              let newArr = addPhotpOrVideo.slice();
              newArr = [...newArr, ...e.target.files];
              setAddPhotoOrVideo(newArr?.slice(0, 8));
            }}
            onClick={(event) => {
              event.target.value = null;
            }}
          />
        </Col>

        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          {addPhotpOrVideo?.length > 0 && (
            <h6
              className={classes.noOfUploadedFiles}
              style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}
            >
              Uploaded{" "}
              <span style={{ ...Fonts.h9, color: Colors.mainBlue }}>
                {addPhotpOrVideo?.length}
              </span>{" "}
              of 8 files
            </h6>
          )}
          <Row className="gy-2">
            {addPhotpOrVideo?.length > 0 &&
              addPhotpOrVideo?.map((item, i) => {
                return (
                  <Col md={4} sm={6} xs={6}>
                    <ImageAndVideoBoxWithDeleteBtn
                      item={item}
                      state={addPhotpOrVideo}
                      setter={setAddPhotoOrVideo}
                    />
                  </Col>
                );
              })}
          </Row>
        </Col>
      </Row>
      {/* Buttons Row */}
      <Row className="g-0">
        <Col lg={12}>
          <div
            className={classes.btnsBox}
            style={{
              borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            }}
          >
            <LinkButtonWithIcon
              text={"Go Back"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                width: "max-content",
                height: "56px",
              }}
              onClick={() => history.goBack()}
            />

            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ ...Fonts.b1, width: "162px", height: "56px" }}
              onClick={() => {
                saveAndFinishLater();
                stepForwardAndBackward(1, 2);
              }}
            />
          </div>
        </Col>
      </Row>
      {coverPhoto !== null && (
        <MobileEditPhotoModal
          show={isOpenEditPhotoModal}
          setShow={setIsOpenEditPhotoModal}
          state={coverPhoto}
          onSave={setEditedCoverPhoto}
        />
      )}
    </div>
  );
}
